import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import props from './attrs/props'
import watch from './attrs/watch'
import TextEditor from '@/components/TextEditor'
import ImageUploader from '@/components/ImageUploader'
import LinkInput from '@/components/LinkInput'

export default {
  name: 'ContentForm',
  components: {
    ImageUploader,
    TextEditor,
    LinkInput,
  },
  data,
  methods,
  mounted,
  props,
  watch,
}
